module.exports = __webpack_public_path__ + "static/media/stockhausen_held_2.66962d9e.png";